import { render, staticRenderFns } from "./AzFileUploadItems.vue?vue&type=template&id=d6c4d65e&"
import script from "./AzFileUploadItems.vue?vue&type=script&lang=js&"
export * from "./AzFileUploadItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports